import { Controller } from "@hotwired/stimulus"

// アンカー/目次ジャンプ時に見出しが固定要素の裏に隠れないよう、
// 固定トップバー(52px) + この sticky ページヘッダーの実高さ を測って
// scroll-padding-top を動的に設定する。
// 狭い幅ではタイトル/メタ/ボタン群が折り返してヘッダーが高くなるため、
// CSS の固定値 (156px) では足りない。ResizeObserver で折り返しにも追従する。
export default class extends Controller {
  static values = { topbar: { type: Number, default: 52 }, gap: { type: Number, default: 12 } }

  connect() {
    this.update = this.update.bind(this)
    this.observer = new ResizeObserver(this.update)
    this.observer.observe(this.element)
    window.addEventListener("resize", this.update)
    this.update()
  }

  disconnect() {
    this.observer?.disconnect()
    window.removeEventListener("resize", this.update)
    document.documentElement.style.scrollPaddingTop = ""
  }

  update() {
    const offset = this.topbarValue + this.element.offsetHeight + this.gapValue
    document.documentElement.style.scrollPaddingTop = `${offset}px`
  }
}
